// extracted by mini-css-extract-plugin
var _1 = "RiskNoticeStyle-module__column-notice___pHlpv";
var _2 = "RiskNoticeStyle-module__column-notice___pHlpv";
var _3 = "RiskNoticeStyle-module__info-container___GZrt2";
var _4 = "RiskNoticeStyle-module__info-link___pvTqc";
var _5 = "RiskNoticeStyle-module__info-container___GZrt2";
var _6 = "RiskNoticeStyle-module__info-link___pvTqc";
export { _1 as "column-notice", _2 as "columnNotice", _3 as "info-container", _4 as "info-link", _5 as "infoContainer", _6 as "infoLink" }
